export const nsResources = {
  APP_3_RESOURCE_UI_NS_ALERTS_LIST: 'APP_3_RESOURCE_UI_NS_ALERTS_LIST',
  APP_3_RESOURCE_UI_NS_IAD_SEGMENTS: 'APP_3_RESOURCE_UI_NS_IAD_SEGMENTS',
  APP_3_RESOURCE_UI_NS_INVESTIGATION_PAGE:
    'APP_3_RESOURCE_UI_NS_INVESTIGATION_PAGE',
  APP_3_RESOURCE_UI_NS_RISK_VIEW: 'APP_3_RESOURCE_UI_NS_RISK_VIEW',
  APP_3_RESOURCE_UI_NS_IAD_MATCHING_CONFIG:
    'APP_3_RESOURCE_UI_NS_IAD_MATCHING_CONFIG',
  APP_3_RESOURCE_UI_NS_IAD_ALERT_DETAILS:
    'APP_3_RESOURCE_UI_NS_IAD_ALERT_DETAILS',
  APP_3_RESOURCE_UI_NS_IAD_MATCHING_RUN_INSTANCE:
    'APP_3_RESOURCE_UI_NS_IAD_MATCHING_RUN_INSTANCE',
  APP_3_RESOURCE_UI_NS_IAD_WATCHLIST: 'APP_3_RESOURCE_UI_NS_IAD_WATCHLIST',
  APP_3_RESOURCE_UI_NS_IAD_WHITELIST: 'APP_3_RESOURCE_UI_NS_IAD_WHITELIST',
  APP_3_RESOURCE_UI_NS_IAD_GLOBAL_SETTINGS:
    'APP_3_RESOURCE_UI_NS_IAD_UI_CONFIG_MANAGEMENT',
  APP_3_RESOURCE_UI_AMLS_COMMON_TICKET: 'APP_3_RESOURCE_UI_AMLS_COMMON_TICKET',
  APP_3_RESOURCE_UI_NS_IAD_TICKET_DETAILS:
    'APP_3_RESOURCE_UI_NS_IAD_TICKET_DETAILS',
  APP_3_RESOURCE_UI_ON_DEMAND_SCREENING:
    'APP_3_RESOURCE_UI_ON_DEMAND_SCREENING',
  APP_3_RESOURCE_UI_AMLS_COMMON_NOTIFICATIONS:
    'APP_3_RESOURCE_UI_AMLS_COMMON_NOTIFICATIONS'
};

export const nsUserManagementResourcesArray = {
  nsDashboard: [
    'NS_ALERTS_HITS_CHART_WIDGET',
    'NS_HITS_DISTRIBUTTION_CHART_WIDGET',
    'NS_BUSINESS_SEGMENT_PARAMETERS_CHART_WIDGET',
    'NS_CUSTOMER_VIEW_CHART_WIDGET'
  ],

  nsAlertListing: ['APP_3_RESOURCE_UI_NS_ALERTS_LIST'],

  nsAlertDetails: ['NS_CUSTOMER_PROFILE_WIDGET', 'NS_ALERT_DETAILS_WIDGET']
};

export const nsUserManagementResources = {
  // ns dashboard
  NS_ALERTS_HITS_CHART_WIDGET: 'NS_ALERTS_HITS_CHART_WIDGET',
  NS_HITS_DISTRIBUTTION_CHART_WIDGET: 'NS_HITS_DISTRIBUTTION_CHART_WIDGET',
  NS_BUSINESS_SEGMENT_PARAMETERS_CHART_WIDGET:
    'NS_BUSINESS_SEGMENT_PARAMETERS_CHART_WIDGET',
  NS_CUSTOMER_VIEW_CHART_WIDGET: 'NS_CUSTOMER_VIEW_CHART_WIDGET',

  // ns alert listing
  APP_3_RESOURCE_UI_NS_ALERTS_LIST: 'APP_3_RESOURCE_UI_NS_ALERTS_LIST',

  // ns alert details
  NS_CUSTOMER_PROFILE_WIDGET: 'NS_CUSTOMER_PROFILE_WIDGET',
  NS_ALERT_DETAILS_WIDGET: 'NS_ALERT_DETAILS_WIDGET'
};

export const tmResources = {
  APP_3_RESOURCE_UI_TM_ALERT_LIST_ANOMALIES:
    'APP_3_RESOURCE_UI_TM_ALERT_LIST_ANOMALIES',
  APP_3_RESOURCE_UI_TM_ALERT_LIST_ALERTS:
    'APP_3_RESOURCE_UI_TM_ALERT_LIST_ALERTS',
  APP_3_RESOURCE_UI_TM_DASHBOARD: 'APP_3_RESOURCE_UI_TM_DASHBOARD',
  APP_3_RESOURCE_UI_TM_INVESTIGATION_PAGE:
    'APP_3_RESOURCE_UI_TM_INVESTIGATION_PAGE',
  APP_3_RESOURCE_UI_TM_ANOMALY_MANAGEMENT:
    'APP_3_RESOURCE_UI_TM_ANOMALY_MANAGEMENT',
  APP_3_RESOURCE_UI_TM_ANOMALY_INVESTIGATION:
    'APP_3_RESOURCE_UI_TM_ANOMALY_INVESTIGATION',
  APP_3_RESOURCE_UI_TM_GLOBAL_SETTINGS: 'APP_3_RESOURCE_UI_TM_GLOBAL_SETTINGS',
  APP_3_RESOURCE_UI_TM_CONFIGURATION: 'APP_3_RESOURCE_UI_TM_CONFIGURATION',
  APP_3_RESOURCE_UI_TM_IAD_FULLACCESS: 'APP_3_RESOURCE_UI_TM_IAD_FULLACCESS'
};

export const tmUserManagementResourcesArray = {
  tmDashboard: [
    'TM_ALERTS_ANOMALIES_CHART_WIDGET',
    'TM_ALERTS_YIELD_CHART_WIDGET',
    'TM_NO_ISSUE_L1_CHART_WIDGET',
    'TM_STR_CHART_WIDGET',
    'TM_SEGMENTS_CHART_WIDGET',
    'TM_CUSTOMER_VIEW_CHART_WIDGET',
    'TM_CLUSTER_VIEW_CHART_WIDGET'
  ],

  tmAlertListing: ['TM_ALERTS_LISTING_WIDGET'],
  tmAlertDetails: [
    'APP_3_RESOURCE_UI_TM_ANOMALY_MANAGEMENT',
    'TM_CUSTOMER_PROFILE_WIDGET',
    'TM_ASSOCIATED_CUSTOMER_WIDGET',
    'TM_ASSOCIATED_ACCOUNTS_WIDGET',
    'TM_ANOMALY_DISPOSITION_NOTES_WIDGET',
    'TM_EXPLAINABILITY_WIDGET',
    'TM_TRANSACTION_DETAILS_WIDGET',
    'TM_ALERT_DETAILS_WIDGET',
    'TM_CUSTOMER_ACTIVITY_WIDGET',
    'TM_ADDITIONAL_INFO_WIDGET',
    'TM_RISK_INDICATOR_WIDGET',
    'TM_CLUSTER_INFORMATION_WIDGET'
  ]
};

export const tmUserManagementResources = {
  // tm dashboard
  TM_ALERTS_ANOMALIES_CHART_WIDGET: 'TM_ALERTS_ANOMALIES_CHART_WIDGET',
  TM_ALERTS_YIELD_CHART_WIDGET: 'TM_ALERTS_YIELD_CHART_WIDGET',
  TM_NO_ISSUE_L1_CHART_WIDGET: 'TM_NO_ISSUE_L1_CHART_WIDGET',
  TM_STR_CHART_WIDGET: 'TM_STR_CHART_WIDGET',
  TM_SEGMENTS_CHART_WIDGET: 'TM_SEGMENTS_CHART_WIDGET',
  TM_CUSTOMER_VIEW_CHART_WIDGET: 'TM_CUSTOMER_VIEW_CHART_WIDGET',
  TM_CLUSTER_VIEW_CHART_WIDGET: 'TM_CLUSTER_VIEW_CHART_WIDGET',

  // tm alerts listing
  TM_ALERTS_LISTING_WIDGET: 'TM_ALERTS_LISTING_WIDGET',

  // tm alert details
  APP_3_RESOURCE_UI_TM_ANOMALY_MANAGEMENT:
    'APP_3_RESOURCE_UI_TM_ANOMALY_MANAGEMENT',
  TM_CUSTOMER_PROFILE_WIDGET: 'TM_CUSTOMER_PROFILE_WIDGET',
  TM_ASSOCIATED_CUSTOMER_WIDGET: 'TM_ASSOCIATED_CUSTOMER_WIDGET',
  TM_ASSOCIATED_ACCOUNTS_WIDGET: 'TM_ASSOCIATED_ACCOUNTS_WIDGET',
  TM_ANOMALY_DISPOSITION_NOTES_WIDGET: 'TM_ANOMALY_DISPOSITION_NOTES_WIDGET',
  TM_EXPLAINABILITY_WIDGET: 'TM_EXPLAINABILITY_WIDGET',
  TM_TRANSACTION_DETAILS_WIDGET: 'TM_TRANSACTION_DETAILS_WIDGET',
  TM_ALERT_DETAILS_WIDGET: 'TM_ALERT_DETAILS_WIDGET',
  TM_CUSTOMER_ACTIVITY_WIDGET: 'TM_CUSTOMER_ACTIVITY_WIDGET',
  TM_ADDITIONAL_INFO_WIDGET: 'TM_ADDITIONAL_INFO_WIDGET',
  TM_RISK_INDICATOR_WIDGET: 'TM_RISK_INDICATOR_WIDGET',
  TM_CLUSTER_INFORMATION_WIDGET: 'TM_CLUSTER_INFORMATION_WIDGET'
};

export const crsResources = {
  APP_3_RESOURCE_UI_CRS_DASHBOARD: 'APP_3_RESOURCE_UI_CRS_DASHBOARD',
  APP_3_RESOURCE_UI_CRS_CUSTOMER_LIST: 'APP_3_RESOURCE_UI_CRS_CUSTOMER_LIST',
  APP_3_RESOURCE_UI_CRS_CUSTOMER_DETAIL:
    'APP_3_RESOURCE_UI_CRS_CUSTOMER_DETAIL',
  APP_3_RESOURCE_UI_CRS_RISK_INDICATOR_CONFIGURATION:
    'APP_3_RESOURCE_UI_CRS_RISK_INDICATOR_CONFIGURATION',
  APP_3_RESOURCE_UI_CRS_GLOBAL_SETTINGS:
    'APP_3_RESOURCE_UI_CRS_GLOBAL_SETTINGS',
  APP_3_RESOURCE_UI_CRS_CONFIGURE_RULES:
    'APP_3_RESOURCE_UI_CRS_CONFIGURE_RULES',
  APP_3_RESOURCE_UI_CRS_TRIGGER_RE_SCORING:
    'APP_3_RESOURCE_UI_CRS_TRIGGER_RE_SCORING',
  APP_3_RESOURCE_UI_CRS_CHANGE_OR_ACCEPT_RISK_SCORE:
    'APP_3_RESOURCE_UI_CRS_CHANGE_OR_ACCEPT_RISK_SCORE'
};

export const trmResources = {
  APP_3_RESOURCE_UI_TYPOLOGY: 'APP_3_RESOURCE_UI_TYPOLOGY',
  APP_3_RESOURCE_UI_TYPOLOGY_WRITE: 'APP_3_RESOURCE_UI_TYPOLOGY_WRITE',
  APP_3_RESOURCE_UI_RUN_INSTANCE: 'APP_3_RESOURCE_UI_RUN_INSTANCE',
  APP_3_RESOURCE_UI_AMLS_TM_ALERT_DETAILS:
    'APP_3_RESOURCE_UI_AMLS_TM_ALERT_DETAILS',
  APP_3_RESOURCE_UI_AMLS_COMMON_ALERTS: 'APP_3_RESOURCE_UI_AMLS_COMMON_ALERTS',
  APP_3_RESOURCE_UI_TM_GLOBAL_SETTINGS: 'APP_3_RESOURCE_UI_TM_GLOBAL_SETTINGS',
  APP_3_RESOURCE_UI_AMLS_CHAMPION: 'APP_3_RESOURCE_UI_AMLS_CHAMPION',
  APP_3_RESOURCE_UI_AMLS_CHAMPION_UPDATE:
    'APP_3_RESOURCE_UI_AMLS_CHAMPION_UPDATE',
  APP_3_RESOURCE_UI_AMLS_COMMON_TICKET: 'APP_3_RESOURCE_UI_AMLS_COMMON_TICKET',
  APP_3_RESOURCE_UI_AMLS_COMMON_TICKET_WRITE:
    'APP_3_RESOURCE_UI_AMLS_COMMON_TICKET_WRITE',
  APP_3_RESOURCE_UI_AMLS_TM_TICKET_DETAILS:
    'APP_3_RESOURCE_UI_AMLS_TM_TICKET_DETAILS',
  APP_3_RESOURCE_UI_SEGMENT_DETAILS: 'APP_3_RESOURCE_UI_SEGMENT_DETAILS'
};

export const cmResources = {
  APP_7_RESOURCE_UI_CM_GENERIC: 'APP_7_RESOURCE_UI_CM_GENERIC',
  APP_7_RESOURCE_UI_CM_DASHBOARD: 'APP_7_RESOURCE_UI_CM_DASHBOARD',
  APP_7_RESOURCE_UI_CM_ALERT_LIST: 'APP_7_RESOURCE_UI_CM_ALERT_LIST',
  APP_7_RESOURCE_UI_CM_ALERT_HISTORY: 'APP_7_RESOURCE_UI_CM_ALERT_HISTORY',
  APP_7_RESOURCE_UI_CM_OWN_ALERTS_ACTIONS:
    'APP_7_RESOURCE_UI_CM_OWN_ALERTS_ACTIONS',
  APP_7_RESOURCE_UI_CM_OTHERS_ALERTS_ACTIONS:
    'APP_7_RESOURCE_UI_CM_OTHERS_ALERTS_ACTIONS',
  APP_7_RESOURCE_UI_CM_UNASSIGNED_ALERTS_ACTIONS:
    'APP_7_RESOURCE_UI_CM_UNASSIGNED_ALERTS_ACTIONS',
  APP_7_RESOURCE_UI_CM_UNASSIGNED_ALERTS:
    'APP_7_RESOURCE_UI_CM_UNASSIGNED_ALERTS',
  APP_7_RESOURCE_UI_CM_CASES_BY_DEPARTMENT:
    'APP_7_RESOURCE_UI_CM_CASES_BY_DEPARTMENT',
  APP_7_RESOURCE_UI_CM_CASES_BY_INVESTIGATOR:
    'APP_7_RESOURCE_UI_CM_CASES_BY_INVESTIGATOR',
  APP_7_RESOURCE_UI_CM_OWN_CASES_ACTIONS:
    'APP_7_RESOURCE_UI_CM_OWN_CASES_ACTIONS',
  APP_7_RESOURCE_UI_CM_OTHERS_CASES_ACTIONS:
    'APP_7_RESOURCE_UI_CM_OTHERS_CASES_ACTIONS',
  APP_7_RESOURCE_UI_CM_UNASSIGNED_CASES_ACTIONS:
    'APP_7_RESOURCE_UI_CM_UNASSIGNED_CASES_ACTIONS',
  APP_7_RESOURCE_UI_CM_UNASSIGNED_CASES:
    'APP_7_RESOURCE_UI_CM_UNASSIGNED_CASES',
  APP_7_RESOURCE_UI_CM_MANUAL_CASE_CREATION:
    'APP_7_RESOURCE_UI_CM_MANUAL_CASE_CREATION',
  APP_7_RESOURCE_UI_CM_CASE_RESOLUTION_REVIEW:
    'APP_7_RESOURCE_UI_CM_CASE_RESOLUTION_REVIEW',
  APP_7_RESOURCE_UI_CM_DASHBOARD_SUMMARY:
    'APP_7_RESOURCE_UI_CM_DASHBOARD_SUMMARY',
  APP_7_RESOURCE_UI_CM_DASHBOARD_CASES_BY_INVESTIGATOR:
    'APP_7_RESOURCE_UI_CM_DASHBOARD_CASES_BY_INVESTIGATOR',
  APP_7_RESOURCE_UI_CM_OTHERS_DEPARTMENTS:
    'APP_7_RESOURCE_UI_CM_OTHERS_DEPARTMENTS',
  APP_7_RESOURCE_UI_CM_EMAIL_PREFERENCES:
    'APP_7_RESOURCE_UI_CM_EMAIL_PREFERENCES',
  APP_7_RESOURCE_UI_CM_GENERAL_SETTINGS:
    'APP_7_RESOURCE_UI_CM_GENERAL_SETTINGS',
  APP_7_RESOURCE_UI_CM_AUTOMATION_SETTINGS:
    'APP_7_RESOURCE_UI_CM_AUTOMATION_SETTINGS',
  APP_7_RESOURCE_UI_CM_REGULATORY_REPORT:
    'APP_7_RESOURCE_UI_CM_REGULATORY_REPORT',
  APP_7_RESOURCE_UI_CM_WORKFLOW_STATUSES:
    'APP_7_RESOURCE_UI_CM_WORKFLOW_STATUSES',
  APP_7_RESOURCE_UI_CM_OPERATIONAL_REPORT:
    'APP_7_RESOURCE_UI_CM_OPERATIONAL_REPORT',
  APP_7_RESOURCE_UI_CM_WHITELISTS: 'APP_7_RESOURCE_UI_CM_WHITELISTS'
};

export const sandboxResources = {
  APP_3_RESOURCE_UI_SCREENING_SANDBOX: 'APP_3_RESOURCE_UI_SCREENING_SANDBOX'
};

export const CRS_UI_DYNPROPS = 'APP_3_RESOURCE_UI_CRS_DYN_PROPS_LIST_PAGE';
export const CRS_UI_PIPELINES = 'APP_3_RESOURCE_UI_CRS_PIPELINE_LIST_PAGE';

export const NS_UI_DYNPROPS = 'APP_3_RESOURCE_UI_NS_IAD_DYN_PROPS_LIST_PAGE';
export const NS_UI_PIPELINES = 'APP_3_RESOURCE_UI_NS_IAD_PIPELINE_LIST_PAGE';

export const TS_UI_DYNPROPS = 'APP_3_RESOURCE_UI_TS_IAD_DYN_PROPS_LIST_PAGE';
export const TS_UI_PIPELINES = 'APP_3_RESOURCE_UI_TS_IAD_PIPELINE_LIST_PAGE';

export const TM_UI_DYNPROPS = 'APP_3_RESOURCE_UI_TM_IAD_DYN_PROPS_LIST_PAGE';
export const TM_UI_PIPELINES = 'APP_3_RESOURCE_UI_TM_IAD_PIPELINE_LIST_PAGE';
export const TM_UI_RI_DYNPROPS =
  'APP_3_RESOURCE_UI_TM_IAD_RI_DYN_PROPS_LIST_PAGE';
export const TM_UI_TYPOLOGY_DYNPROPS =
  'APP_3_RESOURCE_UI_TM_IAD_TYPOLOGY_DYN_PROPS_LIST_PAGE';
